var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"menu-icon",class:{ 'menu-icon--active': _vm.isActive }},[_c('span',{staticClass:"menu-icon__bar",class:_vm.barClass}),_c('span',{staticClass:"menu-icon__bar",class:_vm.barClass}),_c('span',{staticClass:"menu-icon__bar",class:_vm.barClass})])
}
var staticRenderFns = []

export { render, staticRenderFns }